import { gql } from "lib/apolloClient";
import { organizationSubjectFragment } from "./OrganizationFragments";

export const getOrganizationSubjectGroupsQuery = gql`
  query getOrganizationSubjectGroups(
    $id: ID!
    $filters: SubjectGroupFilterInput
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        subjectGroups(filters: $filters) {
          id
          name
          subjects {
            id
          }
        }
      }
    }
  }
`;

export const getOrganizationGradesQuery = gql`
  query getOrganizationGrades($id: ID!, $filters: GradeFilterInput) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        grades(filters: $filters) {
          id
          name
        }
      }
    }
  }
`;

export const getOrganizationSubjectsQuery = gql`
  query getOrganizationSubjects($id: ID!, $filters: SubjectFilterInput) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        subjects(filters: $filters) {
          ...organizationSubjectItem
        }
      }
    }
  }
  ${organizationSubjectFragment.organizationSubject}
`;

export const getOrganizationSubjectsWithSubjectGroupsQuery = gql`
  query getOrganizationSubjects($id: ID!, $filters: SubjectFilterInput) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        subjects(filters: $filters) {
          ...organizationSubjectItem
          subjectGroup {
            id
            name
          }
        }
      }
    }
  }
  ${organizationSubjectFragment.organizationSubject}
`;

export const getOrganizationSubjectsWithIconQuery = gql`
  query getOrganizationSubjects($id: ID!, $filters: SubjectFilterInput) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        subjects(filters: $filters) {
          ...organizationSubjectItem
          icon
          grades {
            id
          }
        }
      }
    }
  }
  ${organizationSubjectFragment.organizationSubject}
`;
